export default __webpack_public_path__ + "static/media/bg-header.6a954ab0.png";